<mat-progress-spinner
  [mode]="params?.mode"
  [color]="params?.color"
  [diameter]="params?.diameter"
></mat-progress-spinner>